module.exports = __webpack_public_path__ + "img/boxing.b6e34b09.svg";